import { Api } from '../sharedTypes/Api';
import { NEXT_PUBLIC_API_URL_CLIENT_SIDE, NEXT_API_URL_BACKEND_SIDE } from './envs';

// Create a custom fetch function that adds the token to requests (client-side)
export const customFetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  try {
    // Always try to get token - if user is signed in, they should get authenticated requests
    // regardless of whether auth is disabled by default
    const tokenResponse = await fetch('/api/auth/token');

    // Check if we got a successful response
    if (tokenResponse.ok) {
      const { token } = await tokenResponse.json();

      // Add token to headers if it exists
      if (token) {
        console.log('Token found, attaching to request');
        init = {
          ...init,
          headers: {
            ...init?.headers,
            'Authorization': `Bearer ${token}`
          }
        };
      } else {
        console.log('No token available, making unauthenticated request');
      }
    } else {
      console.log('Token endpoint not available or failed, making unauthenticated request');
    }
  } catch (error) {
    console.log('Failed to get token, making unauthenticated request:', error);
  }

  // Make the request (with or without token)
  const response = await fetch(input, init);
  return response;
};

// Create API instance with custom fetch (client-side)
export const apiSwaggerClientSide = new Api({
  baseUrl: NEXT_PUBLIC_API_URL_CLIENT_SIDE,
  baseApiParams: {
    credentials: 'include',
    headers: {
      'Accept': 'application/json'
      // Don't set Content-Type here - let the request type determine it
      // (JSON requests will get 'application/json', FormData gets proper boundary)
    },
    mode: "cors"
  },
  customFetch
});

// Create API instance for server-side (SSR)
// Note: This requires passing the access token explicitly via securityData
export const apiSwaggerServerSide = new Api({
  baseUrl: NEXT_API_URL_BACKEND_SIDE || 'http://localhost:3000',
  baseApiParams: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
});

if (typeof window !== 'undefined') {
  window.apiSwagger = apiSwaggerClientSide;
}

export { apiSwaggerClientSide as apiSwagger }